import React from 'react';
import styled from 'styled-components';

interface AlertProps {
  message: string;
  handleCloseAlert: any;
  type: string;
}

const StyledAlert = styled.div`
  width: 100%;
  margin: 15px;
`;

export default class Alert extends React.Component<AlertProps, any> {
  render() {
    const classes = this.props.type === 'success' ? 'alert-success' : 'alert-danger';
    return (
      <StyledAlert className={`alert on-white-background ${classes}`}>
        <button className="close alert-close" onClick={this.props.handleCloseAlert} type="button">
          <span>&times;</span>
        </button>
        <span className="message">{this.props.message}</span>
      </StyledAlert>
    );
  }
}
